import React, { useState } from 'react';
import { Button, TextField, Modal } from 'gatorcomponents';
import * as Styles from './TicketDialog.styles';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';
import barCodeMockImg from '@/media/billing/barcode.png';

const TicketDialog = ({
  onGoBack,
  digitableLine,
  barCode = null,
  saveTicketAsPDF,
  printTicket,
  labelsLocale,
  isLoading,
}) => {
  const [codeCopied, setCodeCopied] = useState(false);
  const copyToClipboard = useCopyToClipboard();

  const handleCopyToClipboard = () => {
    copyToClipboard(digitableLine);
    setCodeCopied(true);
  };

  const handleSaveTicketAsPDF = () => {
    saveTicketAsPDF && saveTicketAsPDF();
  };

  const handlePrintTicket = () => {
    printTicket && printTicket();
  };

  const handleOnGoBack = (() => {
    onGoBack && onGoBack();
    setCodeCopied(false);
  });

  return (
    <Modal
      maxWidth={800}
      title={labelsLocale.modalTitle}
      onGoBack={handleOnGoBack}
    >
      <Styles.Wrapper>
        <Styles.Instruction>{labelsLocale.instruction}</Styles.Instruction>
        <Styles.BarCode
          variant="default"
          src={barCode != null ? `data:image/png;base64,${barCode}` : barCodeMockImg}
          loading="lazy"
        />
        <Styles.InputWrapper onClick={handleCopyToClipboard}>
          <TextField
            traillingIcon={codeCopied ? 'IconCheck' : 'IconCopy'}
            value={digitableLine}
            label="Código"
          />
        </Styles.InputWrapper>
        <Styles.PaymentTips>
          <Styles.TipItem>
            <Styles.Number>1</Styles.Number>
            <Styles.TipText>
              {labelsLocale.ticketTipLabels[0]}
            </Styles.TipText>
          </Styles.TipItem>

          <Styles.TipItem>
            <Styles.Number>2</Styles.Number>
            <Styles.TipText>
              {labelsLocale.ticketTipLabels[1]}
            </Styles.TipText>
          </Styles.TipItem>

          <Styles.TipItem>
            <Styles.Number>3</Styles.Number>
            <Styles.TipText>
              {labelsLocale.ticketTipLabels[2]}
            </Styles.TipText>
          </Styles.TipItem>
        </Styles.PaymentTips>
      </Styles.Wrapper>
      <Styles.Actions>
        <Button
          label={labelsLocale.saveTicketButton}
          size="medium2"
          variant="tertiary"
          onClick={handleSaveTicketAsPDF}
        />

        <Button
          label={labelsLocale.printTicketButton}
          size="medium2"
          variant="primary"
          onClick={handlePrintTicket}
          loading={isLoading}
        />
      </Styles.Actions>
    </Modal>
  );
};

export default TicketDialog;
